module.exports = __webpack_public_path__ + "img/lucas-shigihara.871603a8.jpg";